import "../styles/navbar.css"
export const Navbar = ()=>{
    return(
        <header>
        <div>
            <div className="comp_name">
            <div className="MnameDiv">
            <p>AUTOMOBILE-SERVICES</p>
            </div>
                
                <div className="MimgDiv">
                <img className="img1" src="https://img.icons8.com/ios-filled/50/000000/gear.png"/>
                <img className="img2" src="https://img.icons8.com/ios-filled/50/000000/gear.png"/>
                <img className="img3" src="https://img.icons8.com/ios-filled/50/000000/gear.png"/>
                </div>
              
            </div>
        </div>
        </header>
    )
}